/* AramCrochet: keep the layout right when the page is shown in another language.
   1. The brand name, logo, prices and fixed badges are marked "do not translate",
      so browser translation (Chrome / Google Translate / Safari) never mangles them.
   2. When a browser translates the page, the text changes length without a resize event,
      so every layout script (tabs indicator, arrows, footer wordmark, gallery rail) is told to re-measure. */
(function () {
  var KEEP = [
    '.ac-ft-mark', '.cstitch-wordmark', '.header-logo', '.header__heading', '[class*="logo"]',
    '.pc-bs-price', '.pc-bs-compare', '.pc-pd-price', '.pc-pd-compare', '.price', '[class*="price-item"]',
    '.pc-pd-guarantee-badge', '.ac-ft-copy', '[data-no-translate]'
  ].join(',');

  function mark(root) {
    (root || document).querySelectorAll(KEEP).forEach(function (el) {
      if (el.getAttribute('translate') !== 'no') {
        el.setAttribute('translate', 'no');
        el.classList.add('notranslate');
      }
    });
  }

  var t = null;
  function remeasure() {
    clearTimeout(t);
    t = setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 120);
  }

  function init() {
    mark();
    /* browser translators flag the <html> element (class / lang change) */
    new MutationObserver(remeasure).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'lang', 'dir'] });
    /* re-measure when fonts finish loading too (different scripts use different fonts) */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { mark(e.target); });
})();
